import classnames from 'classnames'
import { InputEmail } from 'Components/PreviewTool/SelectRecipient/components/InputEmail'
import { SelectFilter } from 'Components/PreviewTool/SelectRecipient/components/SelectFilter'
import { SelectGroup } from 'Components/PreviewTool/SelectRecipient/components/SelectGroup'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import './SelectRecipient.scss'

const SelectRecipient = ({
  groups,
  filters,
  filterGroups,
  lastEmails,
  lastFilters,
  lastGroups,
  lastTypeSelected,
  searchRecipientsCallback
}) => {
  const intl = useIntl()
  const [selectedRecipient, setSelectedRecipient] = useState('email')

  useEffect(() => {
    if (lastTypeSelected) {
      setSelectedRecipient(lastTypeSelected)
    }
  }, [lastTypeSelected])

  const handleSelectedRecipient = (recipientType) => {
    setSelectedRecipient(recipientType)
  }

  return (
    <div className='c-select-recipient'>
      <div className='c-select-recipient__header'>
        <h2
          className='c-select-recipient__header__title'
          data-mu-test='select-recipient-header-title'
        >
          {intl.formatMessage({
            id: 'Load.PreviewViewer.SelectARecipient'
          })}
        </h2>
        <span className='c-select-recipient__header__subtitle'>
          {intl.formatMessage({
            id: 'Load.PreviewViewer.SelectARecipientDescr'
          })}
        </span>
      </div>

      <div className='c-select-recipient__category'>
        {/* Email */}
        <div
          className='c-select-recipient__category__item'
          data-mu-test='select-recipient-email'
        >
          <div
            className={classnames('c-select-recipient__category__item__title', {
              'c-select-recipient__category__item__title--active':
                selectedRecipient === 'email'
            })}
            onClick={() => handleSelectedRecipient('email')}
          >
            <div>
              {intl.formatMessage({
                id: 'Load.MailupCommon.Email'
              })}
            </div>
            <span
              className={classnames(
                'c-select-recipient__category__item__title__chevron',
                {
                  'c-select-recipient__category__item__title__chevron--active':
                    selectedRecipient === 'email'
                }
              )}
            />
          </div>
          <div
            className={classnames('c-select-recipient__category__item__body', {
              'c-select-recipient__category__item__body--active':
                selectedRecipient === 'email'
            })}
          >
            <InputEmail
              lastEmails={lastEmails}
              searchRecipientsCallback={searchRecipientsCallback}
            />
          </div>
        </div>

        {/* Filter */}
        <div className='c-select-recipient__category__item'>
          <div
            className={classnames('c-select-recipient__category__item__title', {
              'c-select-recipient__category__item__title--active':
                selectedRecipient === 'filter'
            })}
            onClick={() => handleSelectedRecipient('filter')}
          >
            <div>
              {intl.formatMessage({
                id: 'Load.Common.Filter'
              })}
            </div>
            <span
              className={classnames(
                'c-select-recipient__category__item__title__chevron',
                {
                  'c-select-recipient__category__item__title__chevron--active':
                    selectedRecipient === 'filter'
                }
              )}
            />
          </div>
          <div
            className={classnames('c-select-recipient__category__item__body', {
              'c-select-recipient__category__item__body--active':
                selectedRecipient === 'filter'
            })}
          >
            <SelectFilter
              options={filters}
              optionGroups={filterGroups}
              lastFilters={lastFilters}
              searchRecipientsCallback={searchRecipientsCallback}
            />
          </div>
        </div>

        {/* Group */}
        <div
          className='c-select-recipient__category__item'
          data-mu-test='select-recipient-group'
        >
          <div
            className={classnames('c-select-recipient__category__item__title', {
              'c-select-recipient__category__item__title--active':
                selectedRecipient === 'group'
            })}
            onClick={() => handleSelectedRecipient('group')}
          >
            <div>
              {intl.formatMessage({
                id: 'Load.Common.Group'
              })}
            </div>
            <span
              className={classnames(
                'c-select-recipient__category__item__title__chevron',
                {
                  'c-select-recipient__category__item__title__chevron--active':
                    selectedRecipient === 'group'
                }
              )}
            />
          </div>
          <div
            className={classnames('c-select-recipient__category__item__body', {
              'c-select-recipient__category__item__body--active':
                selectedRecipient === 'group'
            })}
          >
            <SelectGroup
              groups={groups}
              lastGroups={lastGroups}
              searchRecipientsCallback={searchRecipientsCallback}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default SelectRecipient

SelectRecipient.defaultProps = {
  groups: [],
  filters: [],
  lastEmails: [],
  lastFilters: [],
  lastGroups: []
}

SelectRecipient.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object),
  filters: PropTypes.arrayOf(PropTypes.object),
  lastEmails: PropTypes.arrayOf(PropTypes.object),
  lastFilters: PropTypes.arrayOf(PropTypes.object),
  lastGroups: PropTypes.arrayOf(PropTypes.object),
  searchRecipientsCallback: PropTypes.func,
  filterGroups: PropTypes.any,
  lastTypeSelected: PropTypes.any
}
